import { Router } from '@angular/router';
import { UserService } from 'src/app/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { REFORESTACTION_EVENT_ID } from 'src/environments/environment.local';
import { ReforestactionService } from '../../services/reforestaction.service';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { UserFacade } from 'app/modules/dashboard/facades/user.facade';
import { HelpSectionComponent } from '../help-section/help-section.component';
import { ObjectiveSectionComponent } from '../objective-section/objective-section.component';
import { ImagesSectionComponent } from '../images-section/images-section.component';
import { IntroductionSectionComponent } from '../introduction-section/introduction-section.component';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-reforestaction-page',
  templateUrl: './reforestaction-page.component.html',
  styleUrls: ['./reforestaction-page.component.scss'],
  standalone: true,
  imports: [
    PageHeaderComponent,
    IntroductionSectionComponent,
    ImagesSectionComponent,
    ObjectiveSectionComponent,
    HelpSectionComponent,
  ],
})
export class ReforestactionPageComponent implements OnInit, OnDestroy {
  resizeHandler: any;
  bodyEl: HTMLBodyElement;

  subscriptions: Subscription[] = [];
  startDate!: Date;
  endDate!: Date;
  total = 0;
  isActive = false;
  isSubscribed = false;
  user!: any;

  constructor(
    public responsiveScreenService: ResponsiveScreenService,
    private reforestactionService: ReforestactionService,
    private userFacade: UserFacade,
    private router: Router
  ) {
    this.subscriptions.push(this.userFacade.user$.subscribe((user) => {
      this.user = user;
    }));
  }

  ngOnInit(): void {
    this.resizeHandler = () => {
      this.updateZoom();
    };
    this.bodyEl = document.getElementsByTagName('body')[0];
    window.addEventListener('resize', this.resizeHandler);
    this.updateZoom();

    // Get the reforestAction information
    REFORESTACTION_EVENT_ID.forEach((id) => {
      this.subscriptions.push(
        this.reforestactionService.getEventDetails(id).subscribe(({ data }) => {
          this.startDate = new Date(data.event.start_date * 1000);
          this.endDate = new Date(data.event.end_date * 1000);
          this.isSubscribed = this.isSubscribed ? true : data.event.is_subscribed;

          this.total += data.total_challenge;
          this.isActive = this.endDate > new Date(Date.now()) ? true : false;
        })
      );
    });


  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeHandler);
    this.bodyEl.style.removeProperty('--zoom');
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private updateZoom(): void {
    const zoomFactor = this.getZoomFactor(window.innerWidth);
    this.setBodyZoom(zoomFactor);
  }

  private getZoomFactor(windowWidth: number): number {
    if (windowWidth <= this.responsiveScreenService.breakpoints.HD.max) {
      return 67;
    } else if (
      windowWidth <= this.responsiveScreenService.breakpoints['4K-s'].max
    ) {
      return 80;
    }
    return 100;
  }

  private setBodyZoom(percents: number): void {
    this.bodyEl.style.setProperty('--zoom', (percents / 100).toString());
  }

  subscribeEvent() {
    if (this.user && this.user.data) {
      REFORESTACTION_EVENT_ID.forEach((id) => {
        this.reforestactionService.subscribeToEvent(id).subscribe(() => window.location.reload());
      });
    } else {
      this.router.navigate(['/login']);
    }

  }
}
